const url = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:21022/'
export default url